import { Component } from 'san';
import * as _ from 'lodash';

import { IOrganization, IProject, IUser } from 'src/models';
import { MAX_PROJECT_ID_LEVEL } from 'src/consts';

import IssueProjectsList from '../IssueProjectsList/IssueProjectsList';
import Project from '../Project/Project';

import auditService from 'src/services/audit.service';
import uiService from 'src/services/ui.service';
import toasterService from 'src/services/toaster.service';
import dialogService from 'src/services/dialog.service';
import projectService from 'src/services/project.service';
import uploaderService from 'src/services/uploader.service';
import checkOrganizationService from 'src/services/checkOrganization.service';
import BatchUpload from '../BatchUpload/BatchUpload';
import userService from 'src/services/user.service';
import diffService from 'src/services/diff.service';
import commonService from 'src/services/common.service';

export default class IssueProjectsBlock extends Component {
    static components = {
        'ui-issue-projects-list': IssueProjectsList
    }

    static computed = {
        checkedProjects() {
            const projects = this.data.get('projects');
            return _.filter(projects, { _is_checked: true });
        }
    }

    projectComponent;
    batchUploadComponent;

    constructor(options: any) {
        super(options);
    }

    initData(): {
        auditId: string;    // {{}}
        isSecretProjectEnabled: boolean;
        currentUser: IUser;
        projects: IProject[];
        projectsSnapshot: IProject[]; // 实时项目数据快照（进入组件时保存快照，用来和 projects 对比，判断是否 dirty）
        showingProjectCallback: (isShowingProjectComponent: boolean) => void;
        batchUploadCallback: (batchUploadEle: any) => void;
        updatedCallback: (projectGroup: { // 项目列表数据变化（导入、创建、修改，不含删除）的回调
            updatedProjects: IProject[];  // 本次变化的项目
            allDirtyProjects: IProject[]; // 所有变化的项目
        }) => void;
    } {
        return {
            auditId: undefined,
            currentUser: undefined,
            projects: [],
            projectsSnapshot: [],
            showingProjectCallback: null,
            batchUploadCallback: null,
            updatedCallback: null,
            isSecretProjectEnabled: false,
        };
    }

    inited() {
        this.getAuditProjects(this.data.get('auditId'));
    }

    attached() {
        userService.getCurrentUser().then((currentUser) => {
            this.data.set('currentUser', currentUser);
        });
    }

    disposed() {
        if (this.projectComponent) {
            this.projectComponent.dispose();
        }
        this.projectComponent = null;

        if (this.batchUploadComponent) {
            this.batchUploadComponent.dispose();
        }
        this.batchUploadComponent = null;
    }

    //#region owner调用
    //  获取数据
    getDataSync(): { projects: IProject[] } {
        let projects = uiService.zipAuditProjectsIsNeedReceiptSync(this.data.get('projects'));
        projects = uiService.zipAuditProjectsIsSecretSync(projects);
        projects = uiService.zipAuditProjectsEndOnSync(projects);
        return {
            projects
        };
    }
    // 数据校验
    verifySync(): boolean {
        const projects = this.data.get('projects');
        return projectService.verifyProjectsSync({
            scene: 'project-issue',
            projects
        });
    }
    // 是否变更过
    getIsDirtySync(): boolean {
        const projects = this.data.get('projects');
        const projectsSnapshot = this.data.get('projectsSnapshot');
        return diffService.getIsProjectsDirty(projects, projectsSnapshot);
    }
    // 重置是否变更过
    resetIsDirtySync() {
        let dataKey = 'projects';
        const projects = this.data.get(dataKey);
        dataKey = 'projectsSnapshot';
        const projectsSnapshot = this.data.get(dataKey);
        this.data.splice(dataKey, [0, projectsSnapshot.length, ...projects]);
    }
    // 更新auditId，并更新文件上传server地址
    updateAuditIdSync(auditId: string) {
        this.data.set('auditId', auditId);
        const currentUserId = this.data.get('currentUser').user_id;
        const serverUrl = `/api/files/import-projects?audit_id=${auditId}&user_id=${currentUserId}`;
        uploaderService.updateServerUrl('#batchUpload', serverUrl); // 更新文件上传server地址
    }
    //#endregion

    uploadSuccessCallback(projects: IProject[]) {
        const oldProjects: IProject[] = this.data.get('projects');
        _.forEach(projects, project => {
            project._attachments = [];
        });
        // projects = projectService.unzipProjectsDelayEndOn(projects);
        projects = uiService.unzipAuditProjectsIsNeedReceiptSync(projects);
        projects = uiService.unzipAuditProjectsIsSecretSync(projects);
        projects = uiService.unzipAuditProjectsEndOnSync(projects);
        projects = uiService.assignAuditProjectsSnSync([...oldProjects, ...projects]);
        this.data.splice('projects', [0, oldProjects.length, ...projects]);
        toasterService.show({ type: 'success', title: '导入成功' });
        this.callbackUpdated(projects);
    }

    getAuditProjects(auditId: string) {
        let dataKey = 'projects';
        const oldProjects = this.data.get(dataKey);
        auditService.getAuditProjects(auditId).then(projects => {
            this.data.splice(dataKey, [0, oldProjects.length, ...projects]);

            // 记录实时项目列表快照
            dataKey = 'projectsSnapshot';
            const projectsSnapshot = this.data.get(dataKey);
            this.data.splice(dataKey, [0, projectsSnapshot.length, ...projects]);
        });
    }

    // 手动创建Project组件
    private manualCreateProjectComponent() {
        if (!this.projectComponent) {
            this.projectComponent = new Project({
                data: {},
                owner: this,
                source: '<x-project auditId="{{auditId}}" dirtyProjects="{{projects}}" projectAttributesScene="project-issue" isSecretProjectEnabled="{{isSecretProjectEnabled}}" on-create-project="createProject($event)" on-update-project="updateProject($event)" on-show-change="onShowEditingProjectChange($event)"></x-project>'
            });
            this.projectComponent.attach(document.getElementById('app'));
        }
    }

    // 手动创建BatchUpload组件
    private manualCreateBatchUploadComponent() {
        if (!this.batchUploadComponent) {
            this.batchUploadComponent = new BatchUpload({
                data: {},
                owner: this,
                source: '<x-batch-upload auditId="{{auditId}}" batchUploadCallback="{{batchUploadCallback}}" on-show-change="onShowEditingProjectChange($event)" on-upload-success="uploadSuccessCallback($event)"></x-batch-upload>'
            });
            this.batchUploadComponent.attach(document.getElementById('app'));
        }
    }

    //#region 创建项目
    toCreateProject(parentProject?: IProject) {
        this.manualCreateProjectComponent();
        this.projectComponent.create(parentProject);
    }

    toCreateChildProject(project: IProject) {
        this.toCreateProject(project);
    }

    createProject(project: IProject) {
        const dataKey = 'projects';
        const oldProjects = this.data.get(dataKey);
        let projects = [...oldProjects, project];
        // 分配sn
        projects = uiService.assignAuditProjectsSnSync(projects);

        this.data.splice(dataKey, [0, oldProjects.length, ...projects]);
        this.callbackUpdated([project]);
    }

    toCopyProject(project: IProject) {
        const copyProject = _.cloneDeep(project);
        commonService.getNewId().then((id) => {
            copyProject.puid = id;
            copyProject.id = '0';
            const dataKey = 'projects';
            const oldProjects = this.data.get(dataKey);
            let projects = [...oldProjects, copyProject];
            // 分配sn
            projects = uiService.assignAuditProjectsSnSync(projects);

            this.data.splice(dataKey, [0, oldProjects.length, ...projects]);
            this.callbackUpdated([copyProject]);
        });
    }

    private verifyCreateChildProject(checkedProjects: IProject[]): Promise<boolean> {
        if (1 !== checkedProjects.length) {
            toasterService.show({ type: 'warning', title: '请选择一个项目作为父项目' });
            return Promise.resolve(false);
        }
        if (checkedProjects[0].id_level >= MAX_PROJECT_ID_LEVEL) {
            toasterService.show({ type: 'warning', title: '最多只能创建5层项目' });
            return Promise.resolve(false);
        }
        // if (4 === checkedProjects[0].id_level) {
        //     return permissionService.getCurrentCertainPermissionOptionValue('允许创建第5层项目').then(hasPermission => {
        //         if (!hasPermission) {
        //             toasterService.show({ type: 'warning', title: '您没有创建第5层项目的权限' });
        //         }
        //         return hasPermission;
        //     });
        // }
        return Promise.resolve(true);
    }
    //#endregion


    //#region 更新项目
    // 更新全选状态
    toggleCheckAll(isCheckedAll: boolean) {
        const projects: IProject[] = this.data.get('projects');
        _.forEach(projects, project => {
            project._is_checked = isCheckedAll;
        });
        this.data.splice('projects', [0, projects.length, ...projects]);
    }

    toUpdateProject(project: IProject) {
        this.manualCreateProjectComponent();
        const projects = this.data.get('projects');
        const parentProject = _.find(projects, { puid: project.parent_puid });
        this.projectComponent.update(project, parentProject);
    }

    updateProject(project: IProject) {
        const projects = this.data.get('projects');
        const index = _.findIndex(projects, { puid: project.puid });
        if (-1 === index) {
            return;
        }
        projects[index] = project;
        this.data.set('projects', _.cloneDeep(projects));
        this.callbackUpdated([project]);
    }
    //#endregion

    //#region 批量导入
    batchUpload() {
        this.manualCreateBatchUploadComponent();
        this.batchUploadComponent.show();
    }
    //#endregion

    //#region  批量删除项目
    // (删除选中的项目及其子项目)
    toDeleteProjects() {
        const checkedProjects: IProject[] = this.data.get('checkedProjects');
        if (!checkedProjects.length) {
            return;
        }
        dialogService.show({
            title: '提示',
            content: '您确定要删除您选中的这些项目吗？',
            confirmCallback: () => {
                this.deleteProjects(checkedProjects);
            }
        });
    }
    deleteProjects(checkedProjects: IProject[]) {
        const checkedProjectsSns = _.map(checkedProjects, '_sn');
        const oldProjects: IProject[] = this.data.get('projects');
        let projects = _.reject(oldProjects, project => {
            const result = _.some(checkedProjectsSns, sn => {
                return project._sn === sn
                    || _.startsWith(project._sn, `${sn}.`);
            });
            return result;
        });
        projects = uiService.assignAuditProjectsSnSync(projects);
        this.data.splice('projects', [0, oldProjects.length, ...projects]);
        this.callbackUpdated([]);
    }
    //#endregion

    //#region 
    // 设置责任单位
    toSetAccountabilityUnit() {
        const checkedProjects: IProject[] = this.data.get('checkedProjects');
        if (!checkedProjects.length) {
            return;
        }
        checkOrganizationService.show({
            callback: (organization: IOrganization) => {
                this.setAccountabilityUnit(organization);
            }
        })
    }
    setAccountabilityUnit(organization: IOrganization) {
        const projects: IProject[] = this.data.get('projects');
        const checkedProjects: IProject[] = this.data.get('checkedProjects');
        _.forEach(checkedProjects, p => {
            const index = _.findIndex(projects, { puid: p.puid });
            this.data.set(`projects[${index}].accountability_unit_id`, organization.org_number);
            this.data.set(`projects[${index}].accountability_unit`, organization.org_name);
            this.data.set(`projects[${index}].accountability_unit_full_name`, organization.org_full_path);
        });
    }
    //#endregion

    //#region 
    //  编辑项目组件（Project）的 show 状态发生变化，调用callback
    //  批量导入组件（BatchUpload）的 show 状态发生变化，调用callback
    onShowEditingProjectChange(isShowingProjectComponent: boolean) {
        const showingProjectCallback = this.data.get('showingProjectCallback');
        if (showingProjectCallback) {
            showingProjectCallback(isShowingProjectComponent);
        }
    }

    // 项目列表数据变化（导入、创建、修改、删除），调用callback
    callbackUpdated(updatedProjects: IProject[]) {
        const updatedCallback = this.data.get('updatedCallback');
        if (updatedCallback) {
            updatedCallback({
                updatedProjects,
                allDirtyProjects: this.data.get('projects')
            });
        }
    }
    //#endregion
}